import { render, staticRenderFns } from "./TextFieldCurrency.vue?vue&type=template&id=6b94665b&"
import script from "./TextFieldCurrency.vue?vue&type=script&lang=ts&"
export * from "./TextFieldCurrency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports